import { Stack } from "@mui/material";
import InputSettings from "@/components/editor/settings/InputSettings";
import SettingCard from "@/components/SettingCard";
import ClassSettings from "./ClassSettings";
import CalendarSettings from "./CalendarSettings";
import InputIconSettings from "./InputIconSettings";

const DateInputSettings = () => {
  return (
    <Stack spacing={2}>
      <SettingCard title="Clases CSS">
        <ClassSettings />
      </SettingCard>
      <InputSettings />
      <CalendarSettings />
      <InputIconSettings />
    </Stack>
  );
};

export default DateInputSettings;
